import React, { useEffect } from "react";
import Auth from "@/components/Auth";
import { getToken } from "@/services/auth";
import { useNavigate } from "react-router-dom";

const AuthPage = () => {
  const navigate = useNavigate();
  const token = getToken();

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, []);

  if (!token) {
    return (
      <div className="flex items-center justify-center w-full h-[100vh]">
        <Auth />
      </div>
    );
  }
};

export default AuthPage;
